module.exports = __webpack_public_path__ + "img/CN-注册1.6b157819.png";